import { render, staticRenderFns } from "./Houseinfo.vue?vue&type=template&id=99b9b09c&scoped=true&"
import script from "./Houseinfo.vue?vue&type=script&lang=js&"
export * from "./Houseinfo.vue?vue&type=script&lang=js&"
import style0 from "./Houseinfo.vue?vue&type=style&index=0&id=99b9b09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b9b09c",
  null
  
)

export default component.exports